module.exports = __webpack_public_path__ + "static/img/carousel-banner-new-car-ms.891d4e2.jpg";